import { render, staticRenderFns } from "./cjgl-app.vue?vue&type=template&id=07fa708e&scoped=true"
import script from "./cjgl-app.vue?vue&type=script&lang=js"
export * from "./cjgl-app.vue?vue&type=script&lang=js"
import style0 from "../../views/ksgl-page/assets/css/base.css?vue&type=style&index=0&id=07fa708e&prod&scoped=true&lang=css&external"
import style1 from "./cjgl-app.vue?vue&type=style&index=1&id=07fa708e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fa708e",
  null
  
)

export default component.exports